export class MeasurementResultList {
  object: PlotResult;
}

export class PlotResult {
  left: number;
  top: number;

  constructor(left: number, top: number) {
    this.left = left;
    this.top = top;
  }
}

export class PlotResultGroup {
  id: string;
  mode: string;
  length: number;
  objectDistance: number;
  coordinate: PlotResult[];
  area: number;
  latestDistance: number;

  constructor(id: string, mode: string, length: number,
    objectDistance: number, area: number, latestDistance: number, coordinate: PlotResult[]) {
    this.id = id;
    this.mode = mode;
    this.length = length;
    this.objectDistance = objectDistance;
    this.coordinate = coordinate;
    this.area = area;
    this.latestDistance = latestDistance;
  }
}

export class AnnotationEmitData {
  modifiedImage: Blob;
  annotationObjects: any;
  measurementObjects: any;
  initDataJson: any;
  isDisable: boolean;

  constructor(modifiedImage: Blob, annotationObjects: any, measurementObjects: any, initDataJson: any, isDisable: boolean) {
    this.modifiedImage = modifiedImage;
    this.annotationObjects = annotationObjects;
    this.measurementObjects = measurementObjects;
    this.initDataJson = initDataJson;
    this.isDisable = isDisable;
  }
}

export class StereoReconstructionResult {
  inspectionImageId: string;
  libVersion: string;
  measurementType: string;
  productInfo: ProductInfo;
  areaInfo: AreaInfo;
  model3DData: Model3DData;
  internalData: string[];
}

export class ProductInfo {
  imgSize: ImgSize;
  adapterType: string;
  ScopeDiameter: number;
  AdapterSerial: string;
  ScopeSerial: string;
}

export class ImgSize {
  width: number;
  height: number;
}

export class AreaInfo {
  roi_LD: AreaRectf;
  roi_RD: AreaRectf;
  mask_LD: Vertices2Df[];
  mask_RD: Vertices2Df[];
}

export class AreaRectf {
  origin: Vertices2Df;
  size: ImgSize;
}

export class Vertices2Df {
  x: number;
  y: number;

  constructor(x: number, y: number) {
    this.x = x;
    this.y = y;
  }
}

export type Line2D = {
  startPoint: Vertices2Df;
  endPoint: Vertices2Df;
}

export class Model3DData {
  point_count: number;
  mesh_count: number;
  point3D: Vertices3Df[];
  textureCoord: Vertices2Df[];
  quality: number[];
  triangles: PoligonID[];
  texture: ImageData;
}

export class Vertices3Df {
  x: number;
  y: number;
  z: number;

  constructor(x: number, y: number, z: number) {
    this.x = x;
    this.y = y;
    this.z = z;
  }
}

export class PoligonID {
  iD1: number;
  iD2: number;
  iD3: number;
  textureId1: number;
  textureId2: number;
  textureId3: number;
}

export class ImageData {
  imgSize: ImgSize;
  buffer: string;
}

export class SetPlotData {
  pntset: PointSetWithInfo;
}

export class PolylineData {
  pnt_ref: Vertices2Df[];
  line_type: number;
  lr: number;
  pnt_poly: Vertices2Df[];
  pnt_count: number;
}

export class PointSetCommonResultWithCode {
  pointSetResult: PointSet;
  returnCode: number;

  constructor() {
    this.pointSetResult = new PointSet();
  }
}

// #region 3D
export class PointSetWithInfo {
  pntset: PointSet;
  segmentID: number;
  flgs: number;
}

export class PointSet {
  msr_pnt: Vertices2Df;
  res_pnt: Vertices2Df;
  msr_pnt_cor: Vertices2Df;
  res_pnt_cor: Vertices2Df;
  pnt_3d: Vertices3Df;
  isMatch: boolean;
}

export class DistanceMeasureData {
  pntset_meas: PointSet[];
  distance: number;
}

export class PointToLineMeasureData {
  pntset_ref: PointSet[];
  pntset_meas: PointSet;
  distance: number;
  foot: PointSet;
  offset: PointSet[];
}

export class DepthMeasureData {
  pntset_ref: PointSet[];
  pntset_meas: PointSet;
  distance: number;
  foot: PointSet;
}

export class AreaLinesMeasureData {
  pntset_meas: PointSet[];
  pnt_count: number;
  area: number;
  length: number;
  crossChecked: number;
  areaCalced: number;
}

export class AreaLines3D {
  pntCount: number;
  pointSets: PointSet[];
}

export class PointSetWithInfo_WithReturnCode {
  pointSetResult: PointSetWithInfo;
  returnCode: number;

  constructor() {
    this.pointSetResult = new PointSetWithInfo();
  }
}
export class PolylineData_WithReturnCode {
  polylineResult: PointSetWithInfo;
  returnCode: number;

  constructor() {
    this.polylineResult = new PointSetWithInfo();
  }
}

export class TipDefectResultData {
  resultPoints: PointSet[];
  resultPointsCount: number;
  defectSurface: number;
  defectTriangle: number;
  defectWithoutTriangle: number;
  defectOverlapTriangle : number;
  contourPointsCount : number;
  contourPlaneFootPoints : PointSet[];
  contourlineFootPoints: PointSet[];
  overlapTriangleFlags : number[];
  nearestDistance: number;
  edge1Distance : number;
  edge2Distance : number;
  tipAngle : number;
  misalign: number;
}

export class MeasurementResultWithReturnCode<T> {
  result: T;
  returnCode: number;
}
export class DistanceMeasureData_WithReturnCode {
  distanceResult: DistanceMeasureData;
  returnCode: number;
}
export class PointToLineMeasureData_WithReturnCode {
  pointToLineResult: PointToLineMeasureData;
  returnCode: number;
}
export class DepthMeasureData_WithReturnCode {
  depthResult: DepthMeasureData;
  returnCode: number;
}
export class AreaLinesMeasureData_WithReturnCode {
  areaLinesResult: AreaLinesMeasureData;
  returnCode: number;
}
// #endregion

// #region IV7
export class PointSet_IV7 {
  msr_pnt: Vertices2Df;
  res_pnt: Vertices2Df;
  pnt_3d: Vertices3Df;
  fmatch: number[];
  isMatch: boolean;
}

export class DistanceMeasureData_IV7 {
  pntset_meas: PointSet_IV7[];
  distance: number;
}

export class PointToLineMeasureData_IV7 {
  pntset_ref: PointSet_IV7[];
  pntset_meas: PointSet_IV7;
  distance: number;
  foot: Vertices2Df[];
}

export class DepthMeasureData_IV7 {
  pntset_ref: PointSet_IV7[];
  pntset_meas: PointSet_IV7;
  distance: number;
  foot: Vertices2Df[];
}

export class AreaMeasureData_IV7 {
  pntset_meas: PointSet_IV7[];
  pnt_count: number;
  area: number;
}

export class LinesMeasureData_IV7 {
  pntset_meas: PointSet_IV7[];
  pnt_count: number;
  length: number;
}

export class AreaLinesIV7 {
  pntCount: number;
  pointSets: PointSet_IV7[];
}

export class PointSet_IV7_WithReturnCode {
  pointSetResult: PointSet_IV7;
  returnCode: number;

  constructor() {
    this.pointSetResult = new PointSet_IV7();
  }
}
export class PolylineData_IV7_WithReturnCode {
  polylineResult: PolylineData;
  returnCode: number;
}
export class DistanceMeasureData_IV7_WithReturnCode {
  distanceResult: DistanceMeasureData_IV7;
  returnCode: number;
}
export class PointToLineMeasureData_IV7_WithReturnCode {
  pointToLineResult: PointToLineMeasureData_IV7;
  returnCode: number;
}
export class DepthMeasureData_IV7_WithReturnCode {
  depthResult: DepthMeasureData_IV7;
  returnCode: number;
}
export class AreaMeasureData_IV7_WithReturnCode {
  areaResult: AreaMeasureData_IV7;
  returnCode: number;
}
export class LinesMeasureData_IV7_WithReturnCode {
  linesResult: LinesMeasureData_IV7;
  returnCode: number;
}
// # endregion

// #region NX
export class PointSet_NX {
  msr_pnt: Vertices2Df;
  res_pnt: Vertices2Df;
  msr_pnt_cor: Vertices2Df;
  res_pnt_cor: Vertices2Df;
  pnt_3d: Vertices3Df;
  acc_val?: number;
  isMatch: boolean;
}

export class DistanceMeasureData_NX {
  pntset_meas: PointSet_NX[];
  distance: number;
}

export class PointToLineMeasureData_NX {
  pntset_ref: PointSet_NX[];
  pntset_meas: PointSet_NX;
  distance: number;
  foot: PointSet_NX;
  offset_section: Vertices2Df[];
  offset_section_count: number;
  offset_3d: Vertices3Df[];
}

export class DepthMeasureData_NX {
  pntset_ref: PointSet_NX[];
  pntset_meas: PointSet_NX;
  distance: number;
  foot: PointSet_NX[];
}

export class AreaMeasureData_NX {
  pntset_meas: PointSet_NX[];
  pnt_count: number;
  area: number;
  perimeter: number;
}

export class LinesMeasureData_NX {
  pntset_meas: PointSet_NX[];
  pnt_count: number;
  length: number;
}

export class AreaLinesNX {
  pntCount: number;
  pointSets: PointSet_NX[];
}

export class PointSet_NX_WithReturnCode {
  pointSetResult: PointSet_NX;
  returnCode: number;

  constructor() {
    this.pointSetResult = new PointSet_NX();
  }
}
export class PolylineData_NX_WithReturnCode {
  polylineResult: PolylineData;
  returnCode: number;
}
export class DistanceMeasureData_NX_WithReturnCode {
  distanceResult: DistanceMeasureData_NX;
  returnCode: number;
}
export class PointToLineMeasureData_NX_WithReturnCode {
  pointToLineResult: PointToLineMeasureData_NX;
  returnCode: number;
}
export class DepthMeasureData_NX_WithReturnCode {
  depthResult: DepthMeasureData_NX;
  returnCode: number;
}
export class AreaMeasureData_NX_WithReturnCode {
  areaResult: AreaMeasureData_NX;
  returnCode: number;
}
export class LinesMeasureData_NX_WithReturnCode {
  linesResult: LinesMeasureData_NX;
  returnCode: number;
}
// # endregion

export enum MeasurementType {
  Distance = 0,
  PointToLine = 1,
  Depth = 2,
  Lines = 3,
  Area = 4,
  AreaLine2D = 5,
  AreaLine3D = 6
}
